import React, { useEffect, useState } from 'react';
import api from '~/services/api';
import { Label, Input, Select, TextArea } from '~/componentes/CustomForm';
// import CheckBox from '~/componentes/CustomForm/Check/styles/CheckBox';

import { Container, ThisCardAtividade, ThisProgress } from './styles';
// import CustomScrollBar from '~/componentes/CustomScrollBar';
import { Materialize } from '~/styles/materializeGrid';
// import { SLModalFooter } from '~/pages/Sistema/componentes/SistemaList';
import ShowConfirmacao from '~/utils/ShowConfirmacao';
// import Acoordion from '~/componentes/Acoordion';
// import Button from '~/componentes/Button';
// import IconLixeira from '~/assets/icones/IconLixeira.svg';

function CreateContent({ mountedData }) {
  const [status, setStatus] = useState([
    { id: 'A', titulo: 'Aprovado' },
    { id: 'R', titulo: 'Reprovado' },
  ]);
  const [statusAprovacao, setStatusAprovacao] = useState('A');
  const [observacao, setObservacao] = useState(mountedData?.observacao);
  // const [projetos, setProjetos] = useState([]);
  // const [horarios, setHorarios] = useState([]);
  // const [ordemServicoAtividades, setOrdemServicoAtividades] = useState([]);
  const [totalHorasAnalistaDia, setTotalHorasAnalistaDia] = useState('00:00');

  useEffect(() => {
    if (mountedData?.id) {
      api
        .get('/signed/empresa/gestorprojeto/aprovarordemservico/totalhorasanalista', {
          params: { id: mountedData.id },
        })
        .then(response => {
          setTotalHorasAnalistaDia(formatarMinutosMascara(response?.data?.totalMinutos));
        });
    }
  }, [mountedData]);

  const formatarMinutosMascara = totalMinutos => {
    const minutos = parseFloat(totalMinutos || 0);
    const horas = parseInt(minutos / 60);
    const resto = Math.round(minutos % 60);
    return ('00' + horas).slice(-2) + ':' + ('00' + resto).slice(-2);
  };

  async function handleSubmit(data, options) {
    const { closeReload } = options || {};

    return ShowConfirmacao(
      async () => {
        let thisData = { statusAprovacao, id: mountedData?.id, observacao };

        let response = await api.put('/signed/empresa/gestorprojeto/aprovarordemservico', thisData);
        if (response?.status === 200) {
          closeReload && closeReload();
        }

        return response;
      },
      {
        errorModal: {
          defaultMessage: `Ocorreu um erro ao aprovar essa Ordem de Serviço, por favor, tente novamente mais tarde.`,
        },
        message: `Tem certeza que deseja aprovar essa Ordem de Serviço?`,
        successModal: `Ordem de Serviço aprovada com sucesso!`,
      },
    );
  }

  return (
    <Container onSubmit={handleSubmit} defaultScroll={true}>
      <Materialize className="materialize">
        <div className="row">
          <div className="row">
            <div className="item col s12 m6 l9">
              <h6>#{mountedData?.id}</h6>
              <h5 className="titulo">{mountedData?.titulo}</h5>
              <p>Projeto: {mountedData?.projeto?.titulo}</p>
            </div>
            <Label title="Status Aprovação *" className="col s12 m6 l3">
              <Select
                required="true"
                isString
                list={{ list: status, value: 'id', label: 'titulo' }}
                name="statusAprovacao"
                defaultValue={'A'}
                firstOption
                onChange={e => {
                  const v = e.currentTarget.value || 'A';
                  setStatusAprovacao(v);
                }}
              />
            </Label>
          </div>
          <div className="row no-margin">
            <div className="item col s12 m6 l2">
              <div className="item lateral row no-margin">
                <h5>Emissão: </h5>
                <p>
                  {
                    new Date(mountedData?.dataEmissao)
                      .toLocaleString('pt-BR', { timeZone: 'UTC' })
                      .split(',')[0]
                  }
                </p>
              </div>
              <div className="item lateral row no-margin espaco">
                <h5>Hora Apontada: </h5>
                <p>{mountedData?.horaApontada}h</p>
              </div>
              <div className="item lateral row no-margin espaco">
                <h5>Data de Cadastro: </h5>
                <p>
                  {
                    new Date(mountedData?.dataCadastro)
                      .toLocaleString('pt-BR', { timeZone: 'UTC' })
                      .split(',')[0]
                  }
                </p>
              </div>
            </div>
            <div className="item col s12 m6 l2">
              <div className="row no-margin">
                <div className="item lateral row no-margin">
                  <h5>Coordenador: </h5>
                  <p>{mountedData?.coordenador?.nome}</p>
                </div>
                <div className="item lateral row no-margin espaco">
                  <h5>Hora Translado: </h5>
                  <p>{mountedData?.horaTranslado}h</p>
                </div>
                <div className="item lateral row no-margin espaco">
                  <h5>Hora de Cadastro: </h5>
                  <p>{mountedData?.horaCadastro}</p>
                </div>
              </div>
            </div>
            <div className="item col s12 m6 l2">
              <div className="row no-margin">
                <div className="item lateral row no-margin">
                  <h5>Analista: </h5>
                  <p>{mountedData?.analista?.nome}</p>
                </div>
                <div className="item lateral row no-margin espaco">
                  <h5>Hora Desconto: </h5>
                  <p>{mountedData?.horaDesconto}h</p>
                </div>
              </div>
            </div>
            <div className="item col s12 m6 l2">
              <div className="row no-margin">
                <div className="item lateral row no-margin">
                  <h5>Cliente: </h5>
                  <p>{mountedData?.cliente?.nomeFantasia}</p>
                </div>
                <div className="item lateral row no-margin espaco">
                  <h5>Hora Total: </h5>
                  <p>{mountedData?.horaTotal}h</p>
                </div>
                <div className="item lateral row no-margin espaco">
                  <h5>Total do Analista no Dia: </h5>
                  <p>{totalHorasAnalistaDia}</p>
                </div>
              </div>
            </div>
            <div className="item col s12 m12 l4">
              <Label title="Observação" className="no-margin">
                <TextArea
                  name="observacao"
                  onChange={e => {
                    const v = e.currentTarget.value || ' ';
                    setObservacao(v);
                  }}
                />
              </Label>
            </div>
          </div>
          <div className="row no-margin list-atv">
            <div className="item col s12 m12 l12">
              <h5>Lista de Atividades: </h5>
            </div>
            <div className="item col s12 m12 l12">
              {mountedData?.atividades?.map((thisData, a) => (
                <ThisCardAtividade className={'card-item'} index={a} ativo={true} key={a}>
                  <div className="top">
                    <div className="content-top">
                      <div className="card-top">
                        <p className="titulo">{thisData?.titulo}</p>
                        <pre className="analista">{thisData?.descricao}</pre>
                      </div>
                    </div>
                  </div>
                  <div className="content-os">
                    <div className="content-progress">
                      <div className="card-content">
                        <p className="titulo">
                          {thisData?.projetoAtividade?.horaUsada}h/
                          {thisData?.projetoAtividade?.horaTotal}h
                        </p>
                        <div className="progress">
                          <ThisProgress
                            backgound={
                              thisData?.projetoAtividade?.horaUsada >
                              thisData?.projetoAtividade?.horaTotal
                                ? 'rgb(255 118 118)'
                                : thisData?.projetoAtividade?.diasAtraso > 0
                                ? 'rgb(182 177 18)'
                                : '#339C89'
                            }
                            width={
                              (thisData?.projetoAtividade?.horaUsada * 100) /
                                thisData?.projetoAtividade?.horaTotal >
                              100
                                ? 100
                                : (thisData?.projetoAtividade?.horaUsada * 100) /
                                    thisData?.projetoAtividade?.horaTotal +
                                  '%'
                            }
                          />
                        </div>
                      </div>
                    </div>
                    <div className="horario">
                      {thisData?.horarios?.map((thisHora, a) => (
                        <div className="item-hora" key={a}>
                          <div className="card-numero">
                            <p className="numero">{a + 1}</p>
                          </div>
                          <div className="card-hora">
                            <p className="hora">
                              {thisHora?.horaInicialMascara} - {thisHora?.horaFinalMascara}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                    <div className="totalizadores">
                      <div className="card-total">
                        <p className="total">Total: {thisData?.horaTotalMascara}</p>
                      </div>
                    </div>
                  </div>
                </ThisCardAtividade>
              ))}
            </div>
          </div>
        </div>
      </Materialize>
    </Container>
  );
}

export default CreateContent;
